<adapt-select-features [availableFeatures]="allFeatures$ | async"
                       [selectedFeatures]="initiallyEnabledFeatures"
                       (featureAdded)="addFeatureToOrganisation($event)"
                       (featureRemoved)="removeFeatureFromOrganisation($event)"></adapt-select-features>
